// Save token to localStorage
export function saveUserToken(token) {
  if (token) {
    localStorage.setItem('User_biostartechnology', token);
  }
}
import axios from "axios";
const baseURL = "https://api-app.nlsvc.com/api/";

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("User_biostartechnology");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 GET request
export const getRequest = async (endpoint, params = {}) => {
  try {
    const response = await api.get(endpoint, { params });
    return response.data;
  } catch (error) {
    console.error("GET request error:", error);
    throw error;
  }
};

// 🔹 POST request
export const postRequest = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("POST request error:", error);
    throw error;
  }
};

// 🔹 PUT request
export const putRequest = async (endpoint, data) => {
  try {
    const response = await api.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("PUT request error:", error);
    throw error;
  }
};

// 🔹 DELETE request
export const deleteRequest = async (endpoint, data = {}) => {
  try {
    const response = await api.delete(endpoint, { data });
    return response.data;
  } catch (error) {
    console.error("DELETE request error:", error);
    throw error;
  }
};

// 🔹 IMAGE/File Upload request
export const ImageFileUpload = async (endpoint, file, fieldName = "file") => {
  try {
    if (!(file instanceof File)) {
      throw new Error("Invalid file object passed!");
    }

    const formData = new FormData();
    formData.append(fieldName, file);

    const response = await api.post(endpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Image upload error:", error);
    throw error;
  }
};

// 🔹 POST request without token
export const postRequestWithoutToken = async (endpoint, data) => {
  try {
    const response = await axios.post(`${baseURL}${endpoint}`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("POST request without token error:", error);
    throw error;
  }
};
